"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextStyled = exports.ContentItemThumbnailPreviewImageStyled = exports.ContentItemThumbnailHamburgerStyled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("./constants");

var _Layout = require("../../atoms/Layout");

var _Image = require("../../atoms/Image");

var _Typography = require("../../atoms/Typography");

var ContentItemThumbnailHamburgerStyled = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "styles__ContentItemThumbnailHamburgerStyled",
  componentId: "sc-695w8k-0"
})({
  width: "".concat(_constants.CONTENT_ITEM_THUMBNAIL_HEIGHT, "px"),
  height: "".concat(_constants.CONTENT_ITEM_THUMBNAIL_HEIGHT, "px"),
  borderWidth: 0,
  borderRightWidth: 1,
  borderStyle: 'solid'
});
exports.ContentItemThumbnailHamburgerStyled = ContentItemThumbnailHamburgerStyled;
var ContentItemThumbnailPreviewImageStyled = (0, _styledComponents.default)(_Image.Image).withConfig({
  displayName: "styles__ContentItemThumbnailPreviewImageStyled",
  componentId: "sc-695w8k-1"
})({
  boxSizing: 'content-box'
});
exports.ContentItemThumbnailPreviewImageStyled = ContentItemThumbnailPreviewImageStyled;
var TextStyled = (0, _styledComponents.default)(_Typography.Text).withConfig({
  displayName: "styles__TextStyled",
  componentId: "sc-695w8k-2"
})({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
});
exports.TextStyled = TextStyled;